import "./wsFloating.css";

function WsFloating() {
    return (
        <a href="https://wa.me/+5491128637522" target="_blank" rel="noreferrer" className="wsFloatingCont">
            <img src="/images/icons/whatsapp.png" alt="WhatsApp" className="wsFloating"/>
        </a>
    );
}

export default WsFloating;